<template>
  <div>
    <v-data-table
      @click:row="expandRow"
      v-if="serviceContracts"
      :headers="headers"
      :expanded.sync="expanded"
      :items="serviceContracts"
      :no-data-text="$t('appointment.table.noData')"
      item-key="type"
      class="table-row-clickable mt-5 caption"
      hide-default-footer
      disable-pagination
      calculate-widths
      disable-sort
      show-expand
    >
        <template v-slot:[`item.type`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="mw-150 text-truncate" v-bind="attrs" v-on="on">
              {{ $t(`type.${item.type}`) }}
            </div>
          </template>
          <span>{{ $t(`type.${item.type}`) }}</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.price`]="{ item }">
        {{ formatMoney(item.price) }}
      </template>

      <template v-slot:[`item.host_tax`]="{ item }">
        {{ item.host_tax }}%
      </template>

      <template v-slot:[`item.discount`]="{ item }">
        {{ item.discount }}%
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex">
          <v-btn @click.prevent="editLine(item)" icon>
            <v-icon color="primary" small>mdi-pencil-outline</v-icon>
          </v-btn>
          <v-btn @click.prevent="deleteLine(item)" icon>
            <v-icon color="red" small>mdi-close-circle-outline</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`expanded-item`]="{ headers, item }">
        <TableServiceContractDetails :headers="headers" :item="item" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { tableServiceContractHeaders } from '@/components/contract/tableServiceContract/tableServiceContractHeaders'
import TableServiceContractDetails from '@/components/contract/tableServiceContract/TableServiceContractDetails'
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'TableServiceContractValues',

  components: {
    TableServiceContractDetails,
  },
  props: {
    serviceContracts: {
      required:true
    }
  },

  data() {
    return {
      expanded: [],
      headers: tableServiceContractHeaders,
    }
  },
  methods: {

    deleteLine(serviceContract) {
      this.$emit('deleteServiceContract', serviceContract)
    },

    editLine(serviceContract) {
      this.$emit('editServiceContract', serviceContract)
    },

    expandRow(item) {
      this.expanded = item === this.expanded[0] ? [] : [item]
    },

    formatMoney(amount) {
      return catalogMonetary(amount)
    }
  },
}
</script>
